module.exports = __webpack_public_path__ + "img/chatbotspl_logo_blue.f0fa1829.png";